import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TestTake from "../components/TestTake";
import { apiService } from "../services/apiService";
import { useError } from "../context/ErrorContext";

const TestTakePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showError } = useError();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const test = location.state?.test;

  if (!test) {
    navigate("/test");
    return null;
  }

  const handleSubmit = async (answers) => {
    try {
      setIsSubmitting(true);

      // Format answers with all required fields
      const formattedAnswers = answers.map((answer) => ({
        questionId: test.questions[answer.questionIndex]._id,
        question: test.questions[answer.questionIndex].question,
        questionIndex: answer.questionIndex,
        answer: String(answer.answer || ""),
        correctAnswer: test.questions[answer.questionIndex].correctAnswer,
        isCorrect: Boolean(answer.isCorrect),
        type: test.questions[answer.questionIndex].type,
      }));

      // Submit test results
      const result = await apiService.post("/api/test-results", {
        testId: test._id,
        answers: formattedAnswers,
      });

      // Immediately navigate after getting result
      navigate("/test/results", {
        state: {
          result,
          testId: test._id,
        },
        replace: true,
      });
    } catch (error) {
      console.error("Error submitting test:", error);
      showError("Failed to submit test");
      setIsSubmitting(false);
      throw error;
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg">
      <TestTake
        questions={test.questions}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        timeLimit={test.settings?.timeLimit}
      />
    </div>
  );
};

export default TestTakePage;
